import { useEffect, useState } from "react";
import { useLocale } from "@/i18n/locale-context";

const LABELS = {
  fr: "Haut de page",
  en: "Back to top",
  nl: "Naar boven",
} as const;

export function BackToTopFab() {
  const { locale } = useLocale();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!visible) return null;
  const label = LABELS[locale as keyof typeof LABELS] ?? LABELS.fr;

  return (
    <button
      type="button"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      aria-label={label}
      title={label}
      className="fixed z-40 bottom-20 right-4 md:bottom-24 md:right-6 inline-flex items-center justify-center rounded-full bg-background text-foreground border border-foreground/15 shadow-lg hover:bg-foreground/5 transition-colors w-11 h-11"
    >
      <span aria-hidden className="text-lg leading-none">↑</span>
    </button>
  );
}